import { Component } from '@angular/core';
import { path_module_public } from '@app/models/routes.name';
import SwiperCore, { Autoplay, Navigation, Pagination, SwiperOptions } from 'swiper';

SwiperCore.use([Navigation, Pagination, Autoplay])

@Component({
  selector: 'swiper-employer-benefit',
  templateUrl: './swiper-employer-benefit.component.html',
  styleUrls: ['./swiper-employer-benefit.component.css']
})
export class SwiperEmployerBenefitComponent {

  public swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 450,
    autoplay: false,
    grabCursor: true,
    preloadImages: true,
    lazy: true,
    pagination: {
      el: '#swiper-pagination-employer-benefit',
      clickable: true,
    },
    navigation: {
      nextEl: '#swiper-pagination-employer-benefit-next',
      prevEl: '#swiper-pagination-employer-benefit-prev',
    }
  }

  constructor() { }


  public get path_module_public(): typeof path_module_public {
    return path_module_public;
  }
}
